<template>
	<VSheet color="am-blue-lighten-97">
		<h6
			v-if="title"
			class="mb-4"
			:class="$isMobile() ? 'text-subtitle-1' : 'text-h6'"
		>
			{{ title }}
		</h6>
		<slot name="large-content" />
		<div v-if="variant === 'cardBox'">
			<p
				v-if="question"
				:class="$isMobile() ? 'text-body-2' : 'text-subtitle-1'"
			>
				{{ question }}
			</p>
			<VRow class="mt-3">
				<VCol
					v-for="item in items.filter((item) => item.value !== 'NONE' && item.value !== 'BOTH')"
					:key="item.value"
				>
					<SelectableCard
						:value="value === item.value || value === 'BOTH'"
						:title="item.text"
						:description="item.description ? item.description : ''"
						@change="selectCardBox(item.value, $event)"
					/>
				</VCol>
			</VRow>
		</div>
		<VRow class="mt-4">
			<VCol
				:class="variant !== 'cardBox' ? 'mt-auto' : ''"
			>
				<p
					v-if="question && variant !== 'cardBox' && variant !== 'alert'"
					:class="$isMobile() ? 'text-body-2' : 'text-subtitle-1'"
				>
					{{ question }}
				</p>
				<VSpacer
					v-if="question && variant !== 'cardBox'"
					class="pt-6 mt-auto"
				/>
				<slot />
				<VSelect
					v-if="variant === 'select'"
					:label="placeholder"
					:items="items"
					outlined
					hide-details
					background-color="white"
					@change="value = $event"
				/>
				<VRadioGroup
					v-else-if="variant === 'radio' && items"
					class="mt-0"
					row
					hide-details
					@change="value = $event"
				>
					<VRadio
						v-for="item in items"
						:key="item.value"
						:label="item.text"
						:value="item.value"
					/>
				</VRadioGroup>
				<VRadioGroup
					v-else-if="variant === 'radio'"
					class="mt-0"
					row
					hide-details
					@change="value = $event"
				>
					<VRadio
						:label="$t('components.simulator.yes').toString()"
						:value="'true'"
					/>
					<VRadio
						:label="$t('components.simulator.no').toString()"
						:value="'false'"
					/>
				</VRadioGroup>
				<DatePicker
					v-if="variant === 'date'"
					:label="placeholder"
					outlined
					hide-details
					background-color="white"
					birthdate
					@change="value = $event"
				/>
				<VCheckbox
					v-if="variant === 'cardBox' && items.find((item) => item.value === 'NONE')"
					:value="value === 'NONE'"
					:label="items.find((item) => item.value === 'NONE').text"
					class="text-subtitle-1 mt-0"
					hide-details
					@click="value === 'NONE' ? value = null : value = 'NONE'"
				/>
				<VSheet v-if="variant === 'alert'">
					<VAlert
						type="warning"
						color="yellow-darken-60"
						outlined
						class="mb-0"
					>
						<div v-html="description" />
					</VAlert>
				</VSheet>
			</VCol>
			<VCol
				v-if="variant !== 'void' && variant !== 'alert'"
				:cols="$isMobile() ? 12 : 4"
				:class="$isMobile() ? '' : 'mt-auto ml-auto pt-0 pl-0'"
			>
				<p class="w-100 text-center text-overline">
					{{ current }}
					{{ $t('components.simulator.progress') }}
				</p>
				<VProgressLinear
					:value="current"
					:buffer-value="100"
					class="mb-2"
				/>
				<VBtn
					class="w-100"
					color="primary"
					large
					:loading="loading"
					@click="next"
				>
					{{ $t('components.simulator.next') }}
				</VBtn>
			</VCol>
		</VRow>
	</VSheet>
</template>

<script lang="ts">
	import Vue, { PropType } from 'vue';
	import Component, { mixins } from 'vue-class-component';
	import { mapActions } from 'vuex';
	import SelectableCard from '@/components/SelectableCard/SelectableCard.vue';
	import { SimulatorItem } from '@/types';

	const Props = Vue.extend({
		props: {
			title: {
				type: String,
				default: undefined
			},
			question: {
				type: String,
				default: undefined
			},
			description: {
				type: String,
				default: undefined
			},
			current: {
				type: Number,
				default: 0
			},
			variant: {
				type: String,
				default: 'radio'
			},
			items: {
				type: Array as PropType<SimulatorItem[]>,
				default: undefined
			},
			placeholder: {
				type: String,
				default: undefined
			},
			loading: {
				type: Boolean,
				default: false
			}
		}
	});

	@Component<FormStep>({
		components: { SelectableCard },
		methods: {
			...mapActions('notification', ['addNotification'])
		}
	})
	export default class FormStep extends mixins(Props) {
		value: null | string | boolean | number = null;

		next(): void {
			if (this.value === null || this.value === '') {
				this.addNotification({
					type: 'error',
					message: this.$t('components.simulator.require').toString()
				});
				return;
			}
			this.$emit('next', this.value);
		}
		selectCardBox(item: string, val: boolean): void {
			const otherItem = this.items.find((i) => i.value !== item && i.value !== 'NONE' && i.value !== 'BOTH');
			if (!otherItem) {
				return;
			}
			if (!val) {
				if (this.value === 'BOTH') {
					this.value = otherItem.value;
				} else {
					this.value = null;
				}
			} else {
				if (this.value === otherItem.value) {
					this.value = 'BOTH';
				} else {
					this.value = item;
				}
			}
		}
	}
</script>
